module.exports = __webpack_public_path__ + "static/media/logo_acsi.1d5310cb.jpg";